/* Xboost extension 476 sets body.top on mobile open but never clears it.
 * Restore only that offset; preserve other dialogs' locks and app behavior.
 */
(() => {
  function restorePageAfterXboostClose() {
    const body = document.body;
    if (!body || body.classList.contains('xbc-body-overlay')) return;
    const offset = body.style.getPropertyValue('top');
    if (!/^-\d+(?:\.\d+)?px$/.test(offset)) return;
    const scrollY = -parseFloat(offset);
    const scrollX = window.scrollX;
    body.style.removeProperty('top');
    window.scrollTo({ top: scrollY, left: scrollX, behavior: 'instant' });
  }
  document.addEventListener('xboost-closed-cart', restorePageAfterXboostClose);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && document.getElementById('xboost-upsell-slide-cart-root')) {
      restorePageAfterXboostClose();
    }
  });
})();
